module.exports = __webpack_public_path__ + "img/logo-login.bc30fb90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-login.png
// module id = OwLT
// module chunks = 1